import React from 'react'
import './Text.css'
export const link = 'link'
export type asType = 'link' | 'span'
interface ITextProps {
    label: string | undefined
    variant?: string
    as?: asType
    to?: string
    style?: React.CSSProperties
    color?: string
    underline?: boolean
    lineHeight?: React.CSSProperties['lineHeight']
    fontWeight?: React.CSSProperties['fontWeight']
    fontSize?: React.CSSProperties['fontSize']
    marginTop?: React.CSSProperties['marginTop']
    marginBottom?: React.CSSProperties['marginBottom']
    marginLeft?: React.CSSProperties['marginLeft']
    marginRight?: React.CSSProperties['marginRight']
    textAlign?: React.CSSProperties['textAlign']
    whiteSpace?: React.CSSProperties['whiteSpace']
    textDecorationLine?: React.CSSProperties['textDecorationLine']
    fontFamily?:
        | 'Poppins'
        | 'Nunito'
        | 'Chewy'
        | 'Montserrat'
        | React.CSSProperties['fontFamily']
}

export default function Text(props: ITextProps) {
    const styles: React.CSSProperties = {
        ...props.style,
        color: props.color,
        fontSize: props.fontSize,
        lineHeight: props.lineHeight,
        fontWeight: props.fontWeight,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        textAlign: props.textAlign,
        fontFamily: props.fontFamily || 'Nunito',
        whiteSpace: props.whiteSpace || 'pre-wrap',
        textDecorationLine: props.textDecorationLine || 'none',
    }

    if (props.as === link && props.to) {
        return (
            <a
                href={props.to}
                className={`${props.underline ? 'underline ' : ''}${
                    props.variant
                }`}
                style={styles}
            >
                {props.label}
            </a>
        )
    }
    if (props.as === 'span') {
        return (
            <span
                className={`${props.underline ? 'underline ' : ''}${
                    props.variant
                }`}
                style={styles}
            >
                {props.label}
            </span>
        )
    }
    return (
        <p
            className={`${props.underline ? 'underline ' : ''}${props.variant}`}
            style={styles}
        >
            {props.label}
        </p>
    )
}
